import { render, staticRenderFns } from "./GameAnnouncement.vue?vue&type=template&id=2d113b0c&scoped=true&"
import script from "./GameAnnouncement.vue?vue&type=script&lang=js&"
export * from "./GameAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./GameAnnouncement.vue?vue&type=style&index=0&id=2d113b0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d113b0c",
  null
  
)

export default component.exports